import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';
import welcomeComponent from '../../vue/marketplace_v2/welcome/index.vue';

setLanguage();

Vue.prototype.i18n = window.i18n;
Vue.use(TurbolinksAdapter);

if (window.welcomeComponent) {
  window.welcomeComponent.$destroy(true);
}

window.welcomeComponent = new Vue({
  el: '#welcome-index',
  components: { welcomeComponent }
});
